import { CommonModule } from '@angular/common';
import {
  Component,
  ContentChild,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { SecurePipe } from '@shared/pipes/secure.pipe';
import { SharedModule } from '@shared/shared.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PickedDateRange } from '../date-range-picker/date-range-picker.component';
import { CustomDetailFilterDirective } from './filter-toggle-dropdown-temp.directive';
import { ThemeService } from '@shared/service/theme.service';
import { DisplayService } from '@core/services/display.service';

@Component({
  selector: 'app-filter-toggle-dropdown',
  templateUrl: './filter-toggle-dropdown.component.html',
  styleUrls: ['./filter-toggle-dropdown.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NgSelectModule,
    TranslateModule,
    SecurePipe,
    AngularSvgIconModule,
    SharedModule,
  ],
})
export class FilterToggleDropdownComponent {
  @ContentChild(CustomDetailFilterDirective)
  customBodyFilter: CustomDetailFilterDirective;

  @Input() showFilter: boolean;
  @Output() showFilterChange = new EventEmitter<boolean>();
  @Output() search = new EventEmitter<any>();
  @Output() clearFilter = new EventEmitter<any>();
  @Output() dateSelected = new EventEmitter<PickedDateRange>();

  isMobile: boolean;
  private displayService = inject(DisplayService);

  constructor() {
    this.onWindowResize();
  }

  onWindowResize(): void {
    this.displayService
      .getBreakpointDeviceObserver()
      .subscribe((res) => {
        this.isMobile = res === 'mobile';
      });
  }

  handleClickOutside(event: Event): void {
    if (!this.isMobile) {
      this.closeFilter(event);
    }
  }

  filterToggle() {
    this.showFilter = !this.showFilter;
    this.showFilterChange.emit(this.showFilter);
  }

  searchFilter() {
    this.dateSelected.emit();
    this.search.emit(true);
  }

  clearSearchFilter() {
    this.showFilter = false;
    this.clearFilter.emit();
  }

  closeFilter(event: Event) {
    if (event) {
      const targetElement = event.target as HTMLElement;
      const classList = targetElement.classList;
      const ignoredClassNames = [
        'container-icon',
        'custom-day',
        'dropdown-menu',
        'fa-times',
        'form-select',
        'icon-size-res',
        'ng-arrow-wrapper',
        'ng-dropdown-panel',
        'ng-dropdown-panel-items',
        'ng-input',
        'ng-option-label',
        'ng-option-marked',
        'ng-select-container',
        'ngb-dp-body',
        'ngb-dp-week',
        'ngb-dp-weekday',
        'ngb-dp-navigation-chevron',
        'text-black-pantone',
      ];

      const ignoredElementIds = [
        'btn-filter',
        'btn-footer',
        'date-picker',
        'item-filter',
        'popupFilter',
      ];

      if (targetElement.closest('#item-filter')) {
        return;
      }

      if (
        classList.length === 0 ||
        targetElement.tagName === 'BODY' ||
        ignoredClassNames.some((className) =>
          classList.contains(className),
        ) ||
        ignoredElementIds.includes(targetElement.id)
      ) {
        return;
      }

      this.showFilter = false;
    }
  }
}
